export const IDENTITY = (_: any): any => _
export const NOOP: () => void = () => {}

export const ASYNC_IDENTITY = async (_: any): Promise<any> => _
export const ASYNC_NOOP = async (): Promise<void> => {}

export const DELAY_MS = async (ms: number): Promise<any> => await new Promise(resolve => setTimeout(resolve, ms))
